import React from 'react';

const PageShell = ({ title, subtitle, children }) => (
  <div style={{ padding:'24px 28px', fontFamily:"'Inter',sans-serif" }}>
    <div style={{ marginBottom:24 }}>
      <h1 style={{ fontSize:22, fontWeight:700, color:'#fff', letterSpacing:'-0.8px', margin:0 }}>{title}</h1>
      <p style={{ fontSize:12, color:'rgba(255,255,255,0.35)', marginTop:4 }}>{subtitle}</p>
    </div>
    {children}
  </div>
);

const _CostosPage = () => (
  <PageShell title="Gestión de Costos" subtitle="Gastos operativos y costos de producto (COGS)">
    <div style={{ background:'#1a1a1a', border:'1px solid rgba(255,255,255,0.07)', borderRadius:18, padding:40, textAlign:'center', color:'rgba(255,255,255,0.3)', fontSize:14 }}>
      Módulo en construcción — próximamente disponible
    </div>
  </PageShell>
);

const _AnalyticsPage = () => (
  <PageShell title="Analytics" subtitle="Análisis de ventas y publicaciones">
    <div style={{ background:'#1a1a1a', border:'1px solid rgba(255,255,255,0.07)', borderRadius:18, padding:40, textAlign:'center', color:'rgba(255,255,255,0.3)', fontSize:14 }}>
      Módulo en construcción — próximamente disponible
    </div>
  </PageShell>
);

const _RentabilidadPage = () => (
  <PageShell title="Rentabilidad" subtitle="Margen de contribución por publicación">
    <div style={{ background:'#1a1a1a', border:'1px solid rgba(255,255,255,0.07)', borderRadius:18, padding:40, textAlign:'center', color:'rgba(255,255,255,0.3)', fontSize:14 }}>
      Módulo en construcción — próximamente disponible
    </div>
  </PageShell>
);

const _InventarioPage = () => (
  <PageShell title="Inventario" subtitle="Control de stock y alertas de reposición">
    <div style={{ background:'#1a1a1a', border:'1px solid rgba(255,255,255,0.07)', borderRadius:18, padding:40, textAlign:'center', color:'rgba(255,255,255,0.3)', fontSize:14 }}>
      Módulo en construcción — próximamente disponible
    </div>
  </PageShell>
);

const ConfiguracionPage = () => (
  <PageShell title="Configuración" subtitle="Ajustes del sistema y conexión con Mercado Libre">
    <div style={{ background:'#1a1a1a', border:'1px solid rgba(255,255,255,0.07)', borderRadius:18, padding:40, textAlign:'center', color:'rgba(255,255,255,0.3)', fontSize:14 }}>
      Módulo en construcción — próximamente disponible
    </div>
  </PageShell>
);
